var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-box"},[_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next","page-count":_vm.totalPage,"page-size":_vm.limit},on:{"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }